"use strict";

angular.module("admin")
	.constant("ACTION_LOG_TYPE_LABELS", {

		// Théorique - Okina (offre)
		AUTOMATIC_IMPORT_CREATE: "Création d'une configuration d'import",
		AUTOMATIC_IMPORT_UPDATE: "Modification d'une configuration d'import",
		AUTOMATIC_IMPORT_DELETE: "Suppression d'une configuration d'import",
		AUTOMATIC_EXPORT_CREATE: "Création d'une configuration d'export",
		AUTOMATIC_EXPORT_UPDATE: "Modification d'une configuration d'export",
		AUTOMATIC_EXPORT_DELETE: "Suppression d'une configuration d'export",
		IMPORT_PARAMETER_UPDATE: "Modification des paramètres globaux d'import",
		EXPORT_PARAMETER_UPDATE: "Modification des paramètres globaux d'export",
		NETWORK_CREATE: "Création d'un réseau",
		NETWORK_UPDATE: "Modification d'un réseau",
		NETWORK_DELETE: "Suppression d'un réseau",
		LINE_CREATE: "Création d'une ligne",
		LINE_UPDATE: "Modification d'une ligne",
		LINE_DELETE: "Suppression d'une ligne",
		LINE_ORDER_VALIDATION: "Validation de l'ordre des lignes",
		CALENDAR_CREATE: "Création d'un calendrier",
		CALENDAR_UPDATE: "Modification d'un calendrier",
		CALENDAR_DELETE: "Suppression d'un calendrier",
		ROUTE_CREATE: "Création d'un itinéraire",
		ROUTE_UPDATE: "Modification d'un itinéraire",
		ROUTE_DELETE: "Suppression d'un itinéraire",
		VEHICLE_JOURNEY_CREATE: "Création d'une course",
		VEHICLE_JOURNEY_UPDATE: "Modification d'une course",
		VEHICLE_JOURNEY_DELETE: "Suppression d'une course",

		// Théorique - Marduk
		GTFS_IMPORT: "Import manuel GTFS",
		NETEX_IMPORT: "Import manuel NeTEx",
		NEPTUNE_IMPORT: "Import manuel Neptune",
		PREDEFINED_IMPORT: "Déclenchement d'une configuration d'import",
		VALIDATION: "Validation d'une offre",
		GTFS_EXPORT: "Export manuel GTFS",
		NETEX_EXPORT: "Export manuel NeTEx",
		NEPTUNE_EXPORT: "Export manuel Neptune",
		FARES_EXPORT: "Export des tarifs",
		STOP_EXPORT: "Export des arrêts",
		PARKING_EXPORT: "Export des parkings",
		POI_EXPORT: "Export des points d'intérêt",

		// Théorique - Tiamat
		PARKING_CREATE: "Création d'un parking",
		PARKING_UPDATE: "Modification d'un parking",
		PARKING_DELETE: "Suppression d'un parking",
		PARKING_DELETE_ALL: "Suppression de tous les parkings",
		POI_CREATE: "Création d'un point d'intérêt",
		POI_UPDATE: "Modification d'un point d'intérêt",
		POI_DELETE: "Suppression d'un point d'intérêt",
		POI_DELETE_ALL: "Suppression de tous les points d'intérêt",
		STOP_PLACE_CREATE: "Création d'un arrêt",
		STOP_PLACE_UPDATE: "Modification d'un arrêt",
		STOP_PLACE_DELETE: "Suppression d'un arrêt",
		STOP_PLACE_MERGE: "Fusion d'arrêts",
		STOP_PLACE_QUAY_DELETE: "Suppression d'un quai",
		STOP_PLACE_QUAY_MOVE: "Déplacement d'un quai",
		STOP_PLACE_RENAME: "Renommage d'un arrêt",
		STOP_PLACE_REOPEN: "Réouverture d'un arrêt",
		STOP_PLACE_TERMINATION: "Fermeture d'un arrêt",
		STOP_PLACE_DELETE_BY_ORGANISATION: "Suppression des arrêts d'une organisation",
		MULTI_MODAL_STOP_PLACE_CREATE: "Création d'un arrêt multimodal",
		MULTI_MODAL_STOP_PLACE_UPDATE: "Modification d'un arrêt multimodal",
		MULTI_MODAL_STOP_PLACE_DELETE: "Suppression d'un arrêt multimodal",
		GBFS_PARKING_IMPORT: "Import GBFS des parkings",
		BIKE_PARKING_CSV_IMPORT: "Import CSV des parkings vélos",
		PARKING_CSV_IMPORT: "Import CSV des parkings",
		RENTAL_BIKE_CSV_IMPORT: "Import CSV des vélos en location",
		POI_CSV_IMPORT: "Import CSV des points d'intérêt",
		STOP_PLACE_NETEX_IMPORT: "Import NeTEx des arrêts",
		TAD_CSV_IMPORT: "Import CSV TAD",
		STOP_PLACE_ACCESSIBILITY_UPDATE: "Modification de l'accessibilité d'un arrêt",
		QUAY_ACCESSIBILITY_UPDATE: "Modification de l'accessibilité d'un quai",
		POI_NETEX_IMPORT: "Import NeTEx des points d'intérêt",
		PARKING_NETEX_IMPORT: "Import NeTEx des parkings",

		// Temps réel - Ishtar
		SUBSCRIPTION_CREATE: "Création d'un abonnement",
		SUBSCRIPTION_UPDATE: "Modification d'un abonnement",
		SUBSCRIPTION_DELETE: "Suppression d'un abonnement",
		SUBSCRIPTION_URL_MAP_CREATE: "Création d'URL d'abonnement",
		SUBSCRIPTION_URL_MAP_UPDATE: "Modification d'URL d'abonnement",
		SUBSCRIPTION_URL_MAP_DELETE: "Suppression d'URL d'abonnement",
		SUBSCRIPTION_CUSTOM_HEADER_CREATE: "Création d'un en-tête personnalisé d'abonnement",
		SUBSCRIPTION_CUSTOM_HEADER_UPDATE: "Modification d'un en-tête personnalisé d'abonnement",
		SUBSCRIPTION_CUSTOM_HEADER_DELETE: "Suppression d'un en-tête personnalisé d'abonnement",
		SUBSCRIPTION_ID_MAPPING_CREATE: "Création d'un préfixe de mapping d'abonnement",
		SUBSCRIPTION_ID_MAPPING_UPDATE: "Modification d'un préfixe de mapping d'abonnement",
		SUBSCRIPTION_ID_MAPPING_DELETE: "Suppression d'un préfixe de mapping d'abonnement",
		SUBSCRIPTION_VALIDATE: "Validation d'un abonnement",
		SIRI_CREATE: "Création d'une configuration SIRI",
		SIRI_UPDATE: "Modification d'une configuration SIRI",
		SIRI_DELETE: "Suppression d'une configuration SIRI",
		SIRI_VALIDATE: "Validation d'une configuration SIRI",
		GTFS_RT_CREATE: "Création d'une configuration GTFS-RT",
		GTFS_RT_UPDATE: "Modification d'une configuration GTFS-RT",
		GTFS_RT_DELETE: "Suppression d'une configuration GTFS-RT",
		GTFS_RT_VALIDATE: "Validation d'une configuration GTFS-RT",
		GBFS_CREATE: "Création d'une configuration GBFS",
		GBFS_UPDATE: "Modification d'une configuration GBFS",
		GBFS_DELETE: "Suppression d'une configuration GBFS",
		GBFS_VALIDATE: "Validation d'une configuration GBFS",
		ID_PROCESSING_CREATE: "Création d'un traitement d'identifiants",
		ID_PROCESSING_UPDATE: "Modification d'un traitement d'identifiants",
		ID_PROCESSING_DELETE: "Suppression d'un traitement d'identifiants",

		// Temps réel - Anshar
		OUTBOUND_SUBSCRIPTION_DELETE_ALL: "Suppression de tous les abonnements sortants",
		OUTBOUND_SUBSCRIPTION_DELETE_BY_REQUESTOR: "Suppression des abonnements sortants d'un demandeur",
		OUTBOUND_SUBSCRIPTION_TERMINATE: "Résiliation d'un abonnement sortant",
		CACHE_CLEAR: "Nettoyage du cache"
	});
